import { api } from '@/api/api';
const storeApi = api.getDataStoreApi();
const UPGRADE_TIME_V12 = 'UPGRADE_TIME_V12';
export const getTime = () => {
    const result = storeApi.getSync(UPGRADE_TIME_V12);
    if (result.suc && result.data != null) {
        return result.data;
    }
    return null;
};
export const setTime = () => {
    storeApi.putSync(UPGRADE_TIME_V12, String(Date.now()));
};
export const updateTime = () => {
    if (getTime() == null) {
        setTime();
    }
};
